var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilePicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 20,
    viewBox: "0 0 17.5 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.5,19.428H7v-2.5l3.75-6.25,5.137,6.25,3.613-2.5Zm0-8.125a1.875,1.875,0,1,1-1.875-1.875A1.875,1.875,0,0,1,19.5,11.3Zm1.676-4.9a17.71,17.71,0,0,0-1.7-1.947,17.714,17.714,0,0,0-1.947-1.7,3.115,3.115,0,0,0-1.776-.824H6.061A1.564,1.564,0,0,0,4.5,3.491V20.366a1.564,1.564,0,0,0,1.563,1.563H20.436A1.564,1.564,0,0,0,22,20.366V8.178A3.115,3.115,0,0,0,21.175,6.4ZM18.588,5.339a17.048,17.048,0,0,1,1.418,1.589H17V3.921a17.031,17.031,0,0,1,1.589,1.417Zm2.161,15.027a.317.317,0,0,1-.312.313H6.061a.317.317,0,0,1-.313-.312V3.491a.317.317,0,0,1,.313-.312h9.688V7.553a.625.625,0,0,0,.625.625h4.375Z",
    transform: "translate(-4.499 -1.928)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePicture);
export default __webpack_public_path__ + "static/media/file-picture.218c3af87ff7de743831c09f11e6691a.svg";
export { ForwardRef as ReactComponent };